import { styled } from '@mui/system';

const Divider = styled('div')`
  border-top: 1px solid ${(props) => props.theme.palette.grey[300]};
  margin-top: 40px;
`;

export default Divider;
